<template lang="pug">
  div
    b-modal(
      :id="modalId"
      @hide="hideModal"
      size="xl"
      @show="resetForm"
      :no-close-on-backdrop="true"
    )
      template(#modal-title)
        h5.modal-title Generar Cotización
      div
        b-row.mb-4
          b-col.d-flex.justify-content-start.align-items-center.ml-3
            span(
              :class="['circle-icon', 'text-title', { 'active': currentStep === 1 }]"
            ) {{ '1' }}
            h2.m-0(:style="titleStyle" :class="{ 'text-title': currentStep === 1 }") Datos del Clientes
          b-col.d-flex.justify-content-center.align-items-center
            span(
            :class="['circle-icon', 'text-title', { 'active': currentStep === 2 }]"
            ) {{ '2' }}
            h2.m-0(:style="titleStyle" :class="{ 'text-title': currentStep === 2 }") Información del Equipo
          b-col.d-flex.justify-content-end.align-items-center.mr-3
            span(
              :class="['circle-icon', 'text-title', { 'active': currentStep === 3 }]"
            ) {{ '3' }}
            h2.m-0(:style="titleStyle" :class="{ 'text-title': currentStep === 3 }") Repuestos
        div(v-if="currentStep === 1")
          StepCliente(:form.sync="form" :$v="$v.form")
        div(v-if="currentStep === 2")
          StepEquipo(:form.sync="form" :$v="$v.form" @image-uploaded="serialImg = $event")
        div(v-if="currentStep === 3")
          GenerarCotizacion(
            :item="item"
            :showModal="true"
            :type="quotationType"
            :dataNewCot="dataNewCot"
            :getQuotationData="getQuotationData"
            @quotation-data="handleQuotationData"
          )
      template(#modal-footer='{ ok, cancel, hide }')
        b-button.secondary-btn(
          size='sm'
          variant='outlined'
          @click='prevStep()'
          v-if="currentStep > 1"
        ) Paso Anterior
        b-button(
          v-if="quotationType === 'update' || (quotationType === 'fullNew' && currentStep < 3)"
          size='sm'
          id="next-step-btn"
          variant='samtek-yellow'
          @click='nextStep()'
          class="ml-auto"
          :disabled="loading"
        )
          b-spinner.mr-2(v-if="loading && currentStep === 3" small)
          | {{ currentStep === 3 ? (loading ? 'Finalizando...' : 'Finalizar') : 'Siguiente Paso' }}
  </template>

<script>
import { mapActions } from 'vuex'
import {
  minLength,
  maxLength,
  required,
  email,
  numeric,
} from 'vuelidate/lib/validators'
import StepCliente from './stepFormOV/stepCliente.vue'
import GenerarCotizacion from './generarCotizacion.vue'
import StepEquipo from './stepFormOV/stepEquipo.vue'

export default {
  name: 'ModalCotizacionNew',
  components: {
    StepCliente,
    StepEquipo,
    GenerarCotizacion,
  },
  props: {
    dataOv: {
      type: Object,
      default: () => ({}),
    },
    modalId: {
      type: String,
      default: 'modal-cotization-completo',
    },
    quotationType: {
      type: String,
      default: 'fullNew',
    },
  },
  data() {
    return {
      quotationData: {},
      item: {},
      currentStep: 1,
      titleStyle: { color: '#566573', 'font-size': '16px' },
      dataNewCot: {
        rut: '',
        nombre: '',
        apellido: '',
        correo: '',
        telefono: '',
        region: '',
        comuna: '',
        direccion: '',
        device_serial_number: '',
        device_picture: '',
        porcentaje_descuento: 0,
        partes: [],
        servicios: [],
      },
      form: {
        cliente_tipo: 'persona', // nuevo campo
        cliente_id: null, // nuevo campo para empresa
        nombre: '',
        apellido: '',
        correo: '',
        telefono: '',
        comentario: '',
        serial_number: '',
        rut: '',
        region: '',
        comuna: '',
        calle: '',
        serie: '',
        rma: '',
      },
      loading: false,
      serialImg: null,
      getQuotationData: false,
    }
  },
  validations() {
    const baseValidations = {
      correo: { required, email, maxLength: maxLength(60) },
      region: { required },
      comuna: { required },
      calle: { required },
      serie: { required, maxLength: maxLength(15), minLength: minLength(15) },
      rma: { required, maxLength: maxLength(10), minLength: minLength(10) },
    }

    // Validaciones condicionales según el tipo de cliente
    if (this.form.cliente_tipo === 'persona') {
      return {
        form: {
          ...baseValidations,
          rut: { required, maxLength: maxLength(10) },
          nombre: { required, minLength: minLength(3) },
          apellido: { required, minLength: minLength(3) },
          telefono: { required, numeric, maxLength: maxLength(11) },
        },
      }
    }
    
    // Para empresa
    return {
      form: {
        ...baseValidations,
        cliente_id: { required },
      },
    }
  },
  methods: {
    ...mapActions('ClientStore', ['listRegiones']),
    ...mapActions('OVStore', [
      'newOportunidadCompleta',
      'updateOvPrecompletada',
    ]),

    hideModal() {
      this.$bvModal.hide(this.modalId)
      this.$emit('close')
    },

    handleQuotationData(data) {
      console.log('Recibiendo quotation-data en ModalCotizacionNew:', data)
      this.quotationData = data
    },

    resetForm() {
      this.currentStep = 1
      this.serialImg = null
      this.form = {
        cliente_tipo: 'persona',
        cliente_id: null,
        nombre: '',
        apellido: '',
        correo: '',
        telefono: '',
        comentario: '',
        serial_number: '',
        rut: '',
        region: '',
        comuna: '',
        calle: '',
        serie: '',
        rma: '',
      }
      this.$v.$reset()
      this.fillPreCompletedData()
    },

    fillPreCompletedData() {
      if (this.dataOv) {
        this.form.nombre = this.dataOv?.nombre || ''
        this.form.apellido = this.dataOv?.apellido || ''
        this.form.correo = this.dataOv?.correo_electronico || ''
        this.form.telefono = this.dataOv?.telefono || ''
        this.form.rut = this.dataOv?.rut || ''
      }
    },

    nextStep() {
      if (this.currentStep === 1) {
        // Validar campos según el tipo de cliente
        let step1Fields = []
        
        if (this.form.cliente_tipo === 'persona') {
          step1Fields = [
            'rut',
            'nombre',
            'apellido',
            'correo',
            'telefono',
            'region',
            'comuna',
            'calle',
          ]
        } else {
          // Para empresa
          step1Fields = [
            'cliente_id',
            'correo',
            'region',
            'comuna',
            'calle',
          ]
        }
        
        this.$v.form.$touch()

        const isStep1Invalid = step1Fields.some(
          (field) => this.$v.form[field] && this.$v.form[field].$invalid
        )
        
        if (isStep1Invalid) {
          this.$bvToast.toast('Por favor, completa los datos requeridos', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
          return
        }
      }

      if (this.currentStep === 2) {
        this.$v.form.serie.$touch()
        this.$v.form.rma.$touch()
      }

      if (this.currentStep < 3) {
        this.currentStep += 1
      } else if (this.currentStep === 3) {
        this.dataOv.id ? this.update() : this.save() // eslint-disable-line
      }
    },

    prevStep() {
      this.currentStep -= 1
    },

    async update() {
      if (this.loading) return
      this.loading = true
      try {
        this.getQuotationData = true
        await this.$nextTick()
        const formData = new FormData()
        formData.append('id_oportunidad_venta', this.dataOv.id)
        
        // Agregar tipo de cliente
        formData.append('cliente_tipo', this.form.cliente_tipo)
        
        if (this.form.cliente_tipo === 'persona') {
          formData.append('rut', this.form.rut)
          formData.append('nombre', this.form.nombre)
          formData.append('apellido', this.form.apellido)
          formData.append('telefono', this.form.telefono)
        } else {
          formData.append('cliente_id', this.form.cliente_id)
        }
        
        formData.append('correo', this.form.correo)
        formData.append('region', this.form.region)
        formData.append('comuna', this.form.comuna)
        formData.append('direccion', this.form.calle)
        formData.append('device_serial_number', this.form.serie)
        formData.append('rma', this.form.rma)

        if (this.serialImg) {
          formData.append('device_picture', this.serialImg)
        }

        // Los datos de cotización deben estar disponibles ahora
        if (this.quotationData && Object.keys(this.quotationData).length > 0) {
          formData.append(
            'requiere_abono',
            this.quotationData.requiere_abono || false
          )
          formData.append(
            'abono_requerido',
            this.quotationData.abono_requerido || 0
          )
          formData.append(
            'requiere_cobro_envio',
            this.quotationData.requiere_cobro_envio || false
          )
          formData.append('costo_envio', this.quotationData.costo_envio || 0)
          formData.append(
            'comentario_vendedor',
            this.quotationData.comentario_vendedor || ''
          )
          formData.append('discount', this.quotationData.discount || 0)

          const partes = this.quotationData.items
            ? this.quotationData.items
                .filter((item) => item.id_parte) // Filtrar items válidos
                .map((item) => ({
                  id_parte: item.id_parte,
                  precio_unitario: item.precio_unitario,
                  partes_cant: item.partes_cant,
                }))
            : []
          formData.append('partes', JSON.stringify(partes))

          const servicios = this.quotationData.servicios
            ? this.quotationData.servicios
                .filter((service) => service && service.id) // Filtrar servicios válidos
                .map((service) => ({
                  id: service.id,
                  cantidad: service.cantidad,
                  precio: service.precio,
                }))
            : []
          formData.append('servicios', JSON.stringify(servicios))

          console.log('Enviando datos de cotización:', {
            partes: partes.length,
            servicios: servicios.length,
            requiere_abono: this.quotationData.requiere_abono,
            discount: this.quotationData.discount,
          })
        } else {
          formData.append('partes', JSON.stringify([]))
          formData.append('servicios', JSON.stringify([]))
          formData.append('requiere_abono', false)
          formData.append('abono_requerido', 0)
          formData.append('requiere_cobro_envio', false)
          formData.append('costo_envio', 0)
          formData.append('comentario_vendedor', '')
          formData.append('discount', 0)

          console.log(
            'No hay datos de cotización, enviando valores por defecto'
          )
        }

        const response = await this.updateOvPrecompletada(formData)

        if (response.status === 200) {
          this.$bvToast.toast('Cotización actualizada correctamente', {
            title: 'Éxito',
            variant: 'success',
            solid: true,
          })
          this.$emit('updated')
          this.hideModal()
        }
      } catch (error) {
        console.error('Error al actualizar cotización:', error)
        
        const errorMessage = error.response?.data?.error || 'Error al actualizar cotización'
        
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.getQuotationData = false
        this.loading = false
      }
    },

    async save() {
      if (this.loading) return
      this.loading = true
      try {
        const formData = new FormData()
        
        // Agregar tipo de cliente
        formData.append('cliente_tipo', this.form.cliente_tipo)
        
        if (this.form.cliente_tipo === 'persona') {
          // Datos para persona
          formData.append('rut', this.form.rut)
          formData.append('nombre', this.form.nombre)
          formData.append('apellido', this.form.apellido)
          formData.append('correo', this.form.correo)
          formData.append('telefono', this.form.telefono)
        } else {
          // Datos para empresa
          formData.append('cliente_id', this.form.cliente_id)
          formData.append('correo', this.form.correo)
        }
        
        // Datos comunes (dirección, región, comuna, etc.)
        formData.append('region', this.form.region)
        formData.append('comuna', this.form.comuna)
        formData.append('direccion', this.form.calle)
        formData.append('device_serial_number', this.form.serie)
        formData.append('rma', this.form.rma)
        
        // Imagen del equipo
        if (this.serialImg) {
          formData.append('device_picture', this.serialImg)
        }
        
        const response = await this.newOportunidadCompleta(formData)
        
        if (response.status === 200) {
          this.$bvToast.toast('Cotización creada correctamente', {
            title: 'Éxito',
            variant: 'success',
            solid: true,
          })
          this.$emit('updated')
          this.hideModal()
        }
      } catch (error) {
        console.error('Error al crear cotización:', error)
        
        // Manejar errores específicos del backend
        const errorMessage = error.response?.data?.error || 'Error al crear cotización'
        
        if (errorMessage.includes('crear empresas')) {
          this.$bvToast.toast(
            'La empresa seleccionada no existe. Por favor, créela desde el módulo de Clientes.',
            {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
            }
          )
        } else if (errorMessage.includes('no encontrado')) {
          this.$bvToast.toast('El cliente seleccionado no se encuentra en el sistema.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        } else {
          this.$bvToast.toast(errorMessage, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        }
      } finally {
        this.loading = false
      }
    },
  },
  async created() {
    try {
      const regiones = await this.listRegiones()
      this.regiones = regiones
    } catch (error) {
      console.error('Error al cargar las regiones:', error)
    }
  },
  watch: {
    currentStep(newVal) {
      if (newVal === 3) {
        this.dataNewCot = {
          ...this.form,
          device_serial_number: this.form.serie,
          direccion: this.form.calle,
          device_picture: this.serialImg,
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .modal-xl {
  max-width: 90vw !important;
}

@media (min-width: 1400px) {
  ::v-deep .modal-xl {
    max-width: 1600px !important;
  }
}
@import '@/style/colors.scss';

@media (min-width: 1500px) {
  ::v-deep .modal-xl {
    max-width: 1400px !important;
  }
}

::v-deep.form-card {
  box-shadow: 0 3px 6px 0 #00000029;
  opacity: 1;
  padding: 15px;

  .title {
    letter-spacing: 0px;
    color: $samtek-black;
    opacity: 1;
    font-weight: 600;
  }
}

.form-group::v-deep label {
  color: $samtek-grey;

  &.active-label {
    color: $samtek-black;
  }
}

::v-deep .filePart {
  display: flex;
  border: 3px dashed gray;
  border-radius: 1rem;
  width: 100%;
  position: relative;
  /* height: 20vh; */
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

::v-deep .filePart span {
  background-color: $samtek-yellow;
  border-radius: 3px;
  color: $samtek-black;
  padding: 1rem;
  font-weight: 600;
}

::v-deep .containerInputFile input[type='file'] {
  /* height: 20vh; */
  opacity: 0;
  position: absolute;
  top: -55px;
  bottom: 0;
  left: 0;
  right: 0;
}

::v-deep .containerInputFile {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 1.8rem;
  padding-bottom: 1.5rem;
}

.em-label {
  color: $samtek-black;
}

.file-dragover {
  border: 3px dashed pink !important;
  background-color: #f0f0f0;
}

.cloud-icon {
  color: $samtek-yellow;
}

.secondary-btn {
  border-color: $samtek-yellow;
  color: $samtek-black;
  font-weight: 600;
}

.primary-btn {
  font-weight: 600;
}

.autocomplete-result-list {
  z-index: 2 !important;
}

.btn-add-item {
  background-color: transparent !important;
  color: black !important;
  border: none !important;
  cursor: pointer;
}

.icon-add {
  color: #fece2f;
}

.trash-icon {
  color: #fece2f;
}

.form-subtitle {
  color: $samtek-black;
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding-left: 0.5em;

  > h3 {
    font-weight: bold;
    font-size: 18px;
    margin: 0;
  }

  + hr {
    margin: 0.5em 0 1.5em;
  }
}

.categoria,
.comentarios {
  display: block;
  font-size: 15px;
  font-weight: normal;
}

.comentario_text,
.categoria_text {
  color: var(--grey-textos-525252, #525252);
  font-family: 'Noto Sans';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.subtitle_repuesto {
  color: var(--negro-textos-23201-c, #23201c);
  font-family: 'Noto Sans';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.title {
  color: var(--negro-textos-23201-c, #23201c);
  font-family: 'Noto Sans';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.textarea-height {
  height: 150px;
}

.circle-icon {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  color: $samtek-black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  background: $samtek-yellow 0% 0% no-repeat padding-box;
  border-radius: 50%;

  &.active {
    background-color: $samtek-yellow 0% 0% no-repeat padding-box;
    color: white;
  }
}

.text-title {
  color: $samtek-black !important;
  font-weight: 700;
  font-size: 16px;
}

::v-deep .secondary-btn {
  border-color: $samtek-yellow;
  color: $samtek-black;

  &:hover {
    color: black;
    background-color: rgba(254, 206, 47, 0.1);
    border-color: #e5b823;
    box-shadow: none;
  }
}
</style>
